import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, isRef as _isRef, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Application", -1)
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_3 = { style: {"color":"red","text-align":"left"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green","text-align":"left"} }, " You are currently registered and logged in, ", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"color":"green"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  style: {"color":"royalblue"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"orangered"}
}
const _hoisted_12 = {
  key: 2,
  style: {"color":"darkred"}
}
const _hoisted_13 = {
  key: 3,
  style: {"color":"green"}
}
const _hoisted_14 = {
  key: 0,
  style: {"color":"orangered"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 0,
  density: "compact",
  style: {"text-align":"left"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Application Date:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, "Program Applied For:", -1)
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "CCW Waiver", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/",
  target: "_blank"
}, "https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/ (new window)", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "DD Waiver", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/",
  target: "_blank"
}, "https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/ (new window)", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "DD Waiver", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/",
  target: "_blank"
}, "https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/ (new window)", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("b", null, "CCW Waiver", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/",
  target: "_blank"
}, "https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/ (new window)", -1)
const _hoisted_40 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_41 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_42 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_43 = {
  key: 0,
  style: {"margin":"5px","padding-left":"10px"}
}
const _hoisted_44 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_45 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_46 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_47 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_48 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("a", {
  href: "documents/CM07-Case-Management-Selection-Form.pdf",
  target: "_blank"
}, "Download the the DD Case Management Selection Form", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("a", {
  href: "documents/CCW-Form-06-Change-of-CMA-Form.pdf",
  target: "_blank"
}, "Download the CCW Case Management Selection Form", -1)
const _hoisted_53 = {
  key: 3,
  style: {"color":"red"}
}
const _hoisted_54 = { style: {"margin":"10px"} }

import { ref, onMounted, watch } from 'vue';
    //import { injectStrict } from '@/Services/Helper/inject-typed'
    //import { AxiosKey } from '@/Services/HttpClient/symbols'
    import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
    import router from '@/Router/router'
    import { useAuth0 } from '@/Services/Auth0/auth0-plugin';
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    import { LookupService } from '@/Services/lookup-service';
    //import { IWaiverType } from '@/Models/IWaiverType';
    import { ParticipantApplicationService } from '@/Services/participant-application-service';
    import { UserService } from '@/Services/user-service';
    import { IParticipantNewApplication } from '@/Models/IParticipantNewApplication';
    import { IParticipantApplication } from '@/Models/IParticipantApplication';
    import { IUser } from '@/Models/IUser'
    import { IPerson } from '../Models/IPerson';
    import { IPersonAddress } from '../Models/IPersonAddress';
    import { IPersonEmail } from '../Models/IPersonEmail';
    import { IPersonPhone } from '../Models/IPersonPhone';
    import { IPersonEmergencyContact } from '../Models/IPersonEmergencyContact';
    import { IParticipantApplicationDocument } from '../Models/IParticipantApplicationDocument';
    import { IDocument } from '../Models/IDocument';
    import { PersonService } from '@/Services/person-service';
    import { PersonAddressService, createPersonAddress } from '@/Services/person-address-service';
    import { PersonEmailService } from '@/Services/person-email-service';
    import { PersonPhoneService } from '@/Services/person-phone-service';
    import { PersonEmergencyContactService, createPersonEmergencyContact } from '@/Services/person-emergency-contact-service';
    import { ParticipantApplicationDocumentService, createParticipantApplicationDocument } from '@/Services/participant-application-document-service';
    import { DocumentService, createDocument } from '@/Services/document-service';
    import { DateHelper } from '@/Services/Helper/date-helper';
    import { StateEnum } from '@/Enums/StateEnum';

    //import { useReCaptcha } from 'vue-recaptcha-v3'

    //let recaptchaInstance = useReCaptcha();
    
    //const recaptcha = async () => {
    //    await recaptchaInstance?.recaptchaLoaded();
    //    const token = await recaptchaInstance?.executeRecaptcha("submit_application");
    //    return token;
    //};
    //let captchaToken = recaptcha().then(token => {
    //    console.log("recaptcha token:", token);
    //});


    import { vMaska } from 'maska'
    interface ValidationError {
        text: string;
    }


export default /*#__PURE__*/_defineComponent({
  __name: 'ParticipantApplication',
  setup(__props) {

    
    const phoneMask = { mask: '(###) ###-####' }
    const ssnMask = { mask: '###-##-####' }
    const medicaidIdMask = { mask: '##-########'}

    const auth0: Auth0 | null = useAuth0();
    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };    

    //const axios = injectStrict(AxiosKey)
    //const form = ref(null)\
    const loadingData = ref(true)
    let isLoading = ref(true)
    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false
    let hasNoApplication = ref(true)
    let requiresEdit = ref(false)
    let auth0UserId = ref()
    let user = ref<IUser | null>(null);
    let auth0User = ref()
    let existingApp = ref<IParticipantApplication | null>(null)
    let participantPortalUserId = ref();

    let valid = true
    let hasErrors = ref(false)
    let validationErrors = ref<ValidationError[]>([]);
    let ccwFields = ref(false)
    let ddFields = ref(false)
    let unknownWaiver = ref(false)

    //const waiverTypes = ref([{}])
    const divisions = ref ([{}])
    const counties = ref([{}])
    const ethnicities = ref([{}])
    const genderTypes = ref([{}])
    const suffixes = ref([{}])
    const addressTypes = ref([{}])
    const states = ref([{}])   
    const phoneTypes = ref([{}]) 
    const emailTypes = ref([{}])
    const preferredMethodsOfContact = ref([{}])
    const contactTypes = ref([{}])
    const cmAgencies = ref([{}])

    //let participantApplication = ref<IParticipantApplication>()
    let firstName = ref('')
    let lastName = ref('')
    let preferredName = ref('')
    let suffixId = ref()
    let divisionId = ref()
    let middleName = ref('')
    let dateOfBirth = ref('')
    let isMilitary = ref(false)
    let isApplyingForAbi = ref(false)
    let isOver21 = ref(false)
    let ssn = ref('')
    let medicaidId = ref('')
    let countyId = ref()
    let ethnicityId = ref()
    let genderId = ref()
    let preferredMethodOfContactId = ref()
    let phoneTypeId = ref()
    let phoneNumber = ref()
    let emailTypeId = ref()
    let emailAddress = ref()        
    let addressTypeId = ref()
    let addressLine1 = ref()
    let addressLine2 = ref()
    let city = ref()
    let stateId = ref()
    let zipCode = ref()
    let showMailing = ref(false)
    let mailingAddressTypeId = ref()
    let mailingAddressLine1 = ref()
    let mailingAddressLine2 = ref()
    let mailingCity = ref()
    let mailingStateId = ref()
    let mailingZipCode = ref()

    let emergencyContactName = ref()
    let emergencyContactContactTypeId = ref()
    let emergencyContactPhoneTypeId = ref()
    let emergencyContactPhoneNumber = ref()
    let emergencyContactEmailTypeId = ref()
    let emergencyContactEmailAddress = ref()
    let emergencyContactAddressTypeId = ref()
    let emergencyContactAddressLine1 = ref()
    let emergencyContactAddressLine2 = ref()
    let emergencyContactCity = ref()
    let emergencyContactStateId = ref()
    let emergencyContactZipCode = ref()
    let emergencyContactPreferredMethodOfContactId = ref()

    let certificationTypeId = ref()
    let cmAgencyWyNumber = ref()

    let isSubmitted = ref(false)

    let statusPending = ref(true);
    let statusDeclined = ref(false);
    let statusAccepted = ref(false);
    let statusMoreInfo = ref(false);

    let person = ref<IPerson | null>(null)
    let personAddresses = ref<IPersonAddress[] | null>(null)
    let personAddress = ref<IPersonAddress | null>(null)
    let personEmail = ref<IPersonEmail | null>(null)
    let personPhone = ref<IPersonPhone | null>(null)
    let personEmergencyContact = ref<IPersonEmergencyContact | null>(null)
    let participantApplicationCmAgencyDocument = ref<IParticipantApplicationDocument | null>(null)
    let cmAgencyDocument = ref<IDocument | null>(null)
    let allowUpload = ref(true)

    LookupService.getDivisions().then(result => divisions.value = result).then(() => isLoading.value = false);
    LookupService.getCounties().then(result => counties.value = result).then(() => isLoading.value = false);
    LookupService.getAddressTypes().then(result => addressTypes.value = result).then(() => isLoading.value = false);
    LookupService.getEmailTypes().then(result => emailTypes.value = result).then(() => isLoading.value = false);
    LookupService.getEthnicities().then(result => ethnicities.value = result).then(() => isLoading.value = false);
    LookupService.getGenders().then(result => genderTypes.value = result).then(() => isLoading.value = false);
    LookupService.getPhoneTypes().then(result => phoneTypes.value = result).then(() => isLoading.value = false);
    LookupService.getPreferredMethodsOfContact().then(result => preferredMethodsOfContact.value = result).then(() => isLoading.value = false);
    LookupService.getContactTypes().then(result => contactTypes.value = result).then(() => isLoading.value = false);
    LookupService.getStates().then(result => states.value = result).then(() => isLoading.value = false);
    
    
    onMounted(async () => {
        console.log('valid: ' + valid);
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                auth0User.value = auth0 ? auth0.user.value : null;
                console.log('Application Page is auth0 authenticated: ' + isAuthenticated);
                if (auth0User.value) {
                    auth0UserId.value = auth0User.value.sub; // Access Auth0 user ID
                    //console.log('Auth0 User ID: ' + auth0UserId.value);
                    const returnUser = await UserService.getByAuth0Id(auth0UserId.value);
                    user.value = returnUser;
                    participantPortalUserId.value = user.value.participantPortalUserId;

                    //check if they have an application already
                    const appResult = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = appResult;
                    //console.log("existing app:" + JSON.stringify(existingApp.value, null, 2));
                    if (existingApp.value != null && existingApp.value.participantPortalUserId == participantPortalUserId.value) {
                        //don't let them submit again.
                        hasNoApplication.value = false;
                        console.log('existingApp.value.applicationResultId: ' + existingApp.value.applicationResultId);
                        switch (existingApp.value.applicationResultId) {
                            case 0:
                                statusPending.value = true;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                            case 1:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = true;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                            case 2:
                                statusPending.value = false;
                                statusDeclined.value = true;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                            case 3:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = true;
                                requiresEdit.value = true; // show edit button
                                allowUpload.value = true;
                                break;
                            default:
                                statusPending.value = true;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                        }

                        console.log('allow upload: ' + allowUpload.value);
                        cmAgencyWyNumber.value = existingApp.value.caseManagementAgencyWyNumber
                        const personResult = await PersonService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        person.value = personResult;
                        //console.log("Person: " + JSON.stringify(person));
                        const personAddressResult = await PersonAddressService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personAddresses.value = personAddressResult;
                        const personEmailResult = await PersonEmailService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmail.value = personEmailResult;
                        const personPhoneResult = await PersonPhoneService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personPhone.value = personPhoneResult;
                        const personEmergencyContactResult = await PersonEmergencyContactService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmergencyContact.value = personEmergencyContactResult;
                        console.log('existingApp.value.participantApplicationId: ' + existingApp.value.participantApplicationId);
                        if (existingApp.value.participantApplicationId > 0) {
                            const participantApplicationDocumentResult = await ParticipantApplicationDocumentService.getByParticipantApplicationId(existingApp.value.participantApplicationId, auth0UserId.value);
                            participantApplicationCmAgencyDocument.value = participantApplicationDocumentResult;
                            console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
                            if (participantApplicationCmAgencyDocument.value.documentId > 0) {
                                const cmAgencyDocumentResult = await DocumentService.getByDocumentId(participantApplicationCmAgencyDocument.value.documentId, existingApp.value.personId, auth0UserId.value);
                                cmAgencyDocument.value = cmAgencyDocumentResult;
                                console.log('document id: ' + cmAgencyDocument.value.documentId);
                                console.log('filename: ' + cmAgencyDocument.value.filename);
                            }                           
                        }                        

                        divisionId.value = existingApp.value.applicationDivisionId;
   
                        onDivisionTypeChange();

                        firstName.value = person.value.firstName;
                        middleName.value = person.value.middleName;
                        lastName.value = person.value.lastName;
                        preferredName.value = person.value.preferredName;
                        suffixId.value = person.value.suffixId == 0 ? null : person.value.suffixId;
                        dateOfBirth.value = (new Date(person.value.dateOfBirth).getFullYear() + "-" + String(new Date(person.value.dateOfBirth).getMonth() + 1).padStart(2, '0') + "-" + String(new Date(person.value.dateOfBirth).getDate()).padStart(2, '0'));
                        ssn.value = person.value.ssn;
                        genderId.value = person.value.genderId;
                        ethnicityId.value = person.value.ethnicityId;
                        medicaidId.value = person.value.medicaidId == undefined ? '' : person.value.medicaidId;
                        isMilitary.value = existingApp.value.isActiveMilitary ? true : false;
                        isApplyingForAbi.value = existingApp.value.isApplyingForAbi ? true : false;
                        countyId.value = existingApp.value.countyId;
                        phoneTypeId.value = personPhone.value.phoneTypeId;
                        phoneNumber.value = personPhone.value.phoneNumber;
                        emailTypeId.value = personEmail.value.emailTypeId;
                        emailAddress.value = personEmail.value.emailAddress;

                        emergencyContactName.value = personEmergencyContact.value.personName;
                        emergencyContactContactTypeId.value = personEmergencyContact.value.contactTypeId;
                        emergencyContactPhoneTypeId.value = personEmergencyContact.value.phoneTypeId;
                        emergencyContactPhoneNumber.value = personEmergencyContact.value.phoneNumber;
                        emergencyContactEmailTypeId.value = personEmergencyContact.value.emailTypeId;
                        emergencyContactEmailAddress.value = personEmergencyContact.value.emailAddress;
                        emergencyContactAddressTypeId.value = personEmergencyContact.value.addressTypeId;
                        emergencyContactAddressLine1.value = personEmergencyContact.value.addressLine1;
                        emergencyContactAddressLine2.value = personEmergencyContact.value.addressLine2;
                        emergencyContactCity.value = personEmergencyContact.value.city;
                        emergencyContactStateId.value = personEmergencyContact.value.stateId;
                        emergencyContactZipCode.value = personEmergencyContact.value.zipCode;
                        emergencyContactPreferredMethodOfContactId.value = personEmergencyContact.value.preferredMethodOfContactId;

                        if (personAddresses.value) {
                            personAddresses.value.forEach((singleAddress) => {

                                if (singleAddress.addressTypeId == 2) {
                                    //console.log('Loading Mailing Address, ID: ' + singleAddress.personAddressId);
                                    showMailing.value = true;
                                    mailingAddressTypeId.value = singleAddress.addressTypeId;
                                    mailingAddressLine1.value = singleAddress.addressLine1;
                                    mailingAddressLine2.value = singleAddress.addressLine2;
                                    mailingCity.value = singleAddress.city;
                                    mailingStateId.value = singleAddress.stateId;
                                    mailingZipCode.value = singleAddress.zipCode;
                                } else {
                                    //console.log('Loading Physical Address, ID: ' + singleAddress.personAddressId);
                                    addressTypeId.value = singleAddress.addressTypeId;
                                    addressLine1.value = singleAddress.addressLine1;
                                    addressLine2.value = singleAddress.addressLine2;
                                    city.value = singleAddress.city;
                                    stateId.value = singleAddress.stateId;
                                    zipCode.value = singleAddress.zipCode;
                                }
                            });
                        }

                        preferredMethodOfContactId.value = person.value.preferredMethodOfContactId;


                    } else {
                        hasNoApplication.value = true;
                        allowUpload.value = true;
                    }
                    //console.log('hasNoApplication: ' + hasNoApplication.value);
                }
            }
        } catch (e) {
            //console.log('Not Authenticated.');
            const errorObj = e as Error;
            console.error('Authentication Error: ' + errorObj.message);
        } finally {
            loadingData.value = false;
        }
    });

    watch(allowUpload, () => {
        console.log("Allow Upload: " + allowUpload.value)
    })

    watch(isSubmitted, () => {
        console.log("Submitted Status: " + isSubmitted.value.toString())
    })

    watch(isOver21, () => {
        console.log("Is Over 21: " + isOver21.value)
    })

    watch(dateOfBirth, (newValue) => {
        if (newValue) {
            const today = new Date();
            const birthDate = new Date(newValue);
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            isOver21.value = age >= 21;
        } else {
            isOver21.value = false;
        }
    });

    // eslint-disable-next-line
    //async function testCaptcha() {
    //    //console.log('Testing Captcha');
    //    var token = await recaptcha();
    //    //console.log('Submit testCaptcha token: ' + token);
    //    if (token != null) {
    //        ParticipantApplicationService.testCaptcha(token)
    //    }
    //}

    // eslint-disable-next-line
    async function saveNewApplication() {
        //console.log('zipCode: ' + zipCode.value);
        //var token = await recaptcha();
        //console.log('Submit testCaptcha token: ' + token);
        //if (token != null) {
            
            try {
                let result = validateForm();
                if (result) {

                    console.log('saving new app')
                                        
                    // get the user
                    if (registered.value == true) {
                        const result = await UserService.getByAuth0Id(auth0UserId.value);
                        user.value = result;
                        participantPortalUserId.value = user.value.participantPortalUserId;
                        console.log('participantPortalUserId:' + participantPortalUserId.value);
                    }
                    const addressTypeId = mailingAddressLine1.value == undefined || mailingAddressLine1.value.trim() === "" ? Number(3) : Number(1);
                    console.log("addressTypeId: " + addressTypeId);
                    const application: IParticipantNewApplication = {
                        participantPortalUserId: participantPortalUserId.value ? Number(participantPortalUserId.value) : undefined,
                        divisionId: Number(divisionId.value),
                        firstName: firstName.value,
                        middleName: middleName.value,
                        lastName: lastName.value,
                        preferredName: preferredName.value ?? '',
                        suffixId: Number(suffixId.value) == 0 ? undefined : Number(suffixId.value),
                        genderId: Number(genderId.value),
                        dateOfBirth: dateOfBirth.value,
                        ssn: ssn.value,
                        medicaidId: medicaidId.value ? medicaidId.value : '',
                        ethnicityId: Number(ethnicityId.value),
                        isActiveMilitary: isMilitary.value.toString(),
                        isApplyingForAbi: isApplyingForAbi.value.toString(),
                        preferredMethodOfContactId: Number(preferredMethodOfContactId.value),
                        countyId: Number(countyId.value),
                        //addressTypeId: mailingAddressLine1.value == undefined || mailingAddressLine1.value == "" ? Number(3) : Number(1),
                        addressTypeId: addressTypeId,
                        addressLine1: addressLine1.value,
                        addressLine2: addressLine2.value ?? '',
                        city: city.value,
                        stateId: Number(stateId.value),
                        zipCode: zipCode.value,
                        mailingAddressTypeId: mailingAddressLine1.value != undefined && mailingAddressLine1.value != "" ? Number(2) : 0,
                        mailingAddressLine1: mailingAddressLine1.value ?? '',
                        mailingAddressLine2: mailingAddressLine2.value ?? '',
                        mailingCity: mailingCity.value ?? '',
                        mailingStateId: Number(mailingStateId.value) ?? 0,
                        mailingZipCode: mailingZipCode.value ?? '',
                        phoneTypeId: Number(phoneTypeId.value),
                        phoneNumber: phoneNumber.value,
                        emailTypeId: Number(emailTypeId.value),
                        emailAddress: emailAddress.value,
                        emergencyContactName: emergencyContactName.value,
                        emergencyContactContactTypeId: emergencyContactContactTypeId.value,
                        emergencyContactPhoneTypeId: Number(emergencyContactPhoneTypeId.value),
                        emergencyContactPhoneNumber: emergencyContactPhoneNumber.value,
                        emergencyContactEmailTypeId: emergencyContactEmailTypeId.value ? Number(emergencyContactEmailTypeId.value) : 0,
                        emergencyContactEmailAddress: emergencyContactEmailAddress.value,
                        emergencyContactAddressTypeId: Number(emergencyContactAddressTypeId.value),
                        emergencyContactAddressLine1: emergencyContactAddressLine1.value,
                        emergencyContactAddressLine2: emergencyContactAddressLine2.value,
                        emergencyContactCity: emergencyContactCity.value,
                        emergencyContactStateId: Number(emergencyContactStateId.value),
                        emergencyContactZipCode: emergencyContactZipCode.value,
                        emergencyContactPreferredMethodOfContactId: emergencyContactPreferredMethodOfContactId.value,
                        caseManagementAgencyWyNumber: cmAgencyWyNumber.value
                    };
                    //console.log('zipCode: ' + zipCode.value);
                    //console.log("Application object:", application);
                    await ParticipantApplicationService.saveNewApplication(application)

                    isSubmitted.value = true
                    console.log('participantPortalUserId at get newApp:' + participantPortalUserId.value);
                    const newApp = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = newApp;

                    //associate any updated document to the new application
                    if (cmAgencyDocument?.value?.documentId != null && cmAgencyDocument?.value?.documentId > 0) {
                        console.log('has doc, associate');

                        participantApplicationCmAgencyDocument.value = createParticipantApplicationDocument();
                        participantApplicationCmAgencyDocument.value.documentId = cmAgencyDocument.value.documentId;
                        participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
                        participantApplicationCmAgencyDocument.value.modifiedBy = 'Create';
                        participantApplicationCmAgencyDocument.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');

                        console.log('participant app id: ' + existingApp.value.participantApplicationId);
                        //console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
                        //participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
                        ParticipantApplicationDocumentService.saveParticipantApplicationDocument(participantApplicationCmAgencyDocument.value, auth0UserId.value);
                    }

                    // redirect to submitted page
                    router.push('submitted');

                } else {
                    isSubmitted.value = false
                }

                console.log("IsSubmitted: " + isSubmitted.value);

            } catch (e: unknown) {
                if (isAxiosError(e)) {
                    console.error(e.response?.data);
                } else {
                    console.error(e); // Log the entire error object if it doesn't have the expected structure
                }
            }

        //}
        
    }

    // eslint-disable-next-line
    async function updateApplication() {

        //var token = await recaptcha();
        //console.log('Submit testCaptcha token: ' + token);
        //if (token != null) {

            try {
                let result = validateForm();
                if (result) {

                    console.log('updating existing app')
                    const appResult = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = appResult;
                    existingApp.value.applicationDivisionId = divisionId.value;
                    const personResult = await PersonService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    person.value = personResult;
                    //console.log("Person: " + JSON.stringify(person));
                    const personAddressResult = await PersonAddressService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personAddresses.value = personAddressResult;
                    const personEmailResult = await PersonEmailService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personEmail.value = personEmailResult;
                    const personPhoneResult = await PersonPhoneService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personPhone.value = personPhoneResult;
                    const personEmergencyContactResult = await PersonEmergencyContactService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personEmergencyContact.value = personEmergencyContactResult;

                    person.value.firstName = firstName.value;
                    person.value.middleName = middleName.value;
                    person.value.lastName = lastName.value;
                    person.value.preferredName = preferredName.value;
                    person.value.suffixId = Number(suffixId.value) == 0 ? undefined : Number(suffixId.value);
                    person.value.dateOfBirth = dateOfBirth.value;
                    person.value.ssn = ssn.value;
                    person.value.genderId = Number(genderId.value);
                    person.value.ethnicityId = Number(ethnicityId.value);
                    person.value.medicaidId = medicaidId.value ? medicaidId.value : undefined;
                    existingApp.value.isActiveMilitary = isMilitary.value.toString() == "true" ? true : false;
                    existingApp.value.isApplyingForAbi = isApplyingForAbi.value.toString() == "true" ? true : false;
                    existingApp.value.countyId = Number(countyId.value);
                    existingApp.value.caseManagementAgencyWyNumber = cmAgencyWyNumber.value;
                    personPhone.value.phoneTypeId = Number(phoneTypeId.value);
                    personPhone.value.phoneNumber = phoneNumber.value;
                    personEmail.value.emailTypeId = Number(emailTypeId.value);
                    personEmail.value.emailAddress = emailAddress.value;

                    if (personEmergencyContact.value.personName == null || personEmergencyContact.value.personName == "")
                    {
                        personEmergencyContact.value = createPersonEmergencyContact();
                    }             

                    personEmergencyContact.value.personId = person.value.personId;
                    personEmergencyContact.value.personName = emergencyContactName.value;
                    personEmergencyContact.value.contactTypeId = emergencyContactContactTypeId.value;
                    personEmergencyContact.value.phoneTypeId = Number(emergencyContactPhoneTypeId.value);
                    personEmergencyContact.value.phoneNumber = emergencyContactPhoneNumber.value;
                    personEmergencyContact.value.emailTypeId = emergencyContactEmailTypeId.value ? Number(emergencyContactEmailTypeId.value) : 0;
                    personEmergencyContact.value.emailAddress = emergencyContactEmailAddress.value;
                    personEmergencyContact.value.addressTypeId = Number(emergencyContactAddressTypeId.value);
                    personEmergencyContact.value.addressLine1 = emergencyContactAddressLine1.value;
                    personEmergencyContact.value.addressLine2 = emergencyContactAddressLine2.value;
                    personEmergencyContact.value.city = emergencyContactCity.value;
                    personEmergencyContact.value.stateId = Number(emergencyContactStateId.value);
                    personEmergencyContact.value.zipCode = emergencyContactZipCode.value;
                    personEmergencyContact.value.preferredMethodOfContactId = emergencyContactPreferredMethodOfContactId.value;
                    personEmergencyContact.value.modifiedBy = "Update";
                    personEmergencyContact.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');

                    person.value.preferredMethodOfContactId = preferredMethodOfContactId.value;

                    PersonService.savePerson(person.value, auth0UserId.value);
                    PersonEmailService.savePersonEmail(personEmail.value, auth0UserId.value);
                    PersonPhoneService.savePersonPhone(personPhone.value, auth0UserId.value);
                    PersonEmergencyContactService.savePersonEmergencyContact(personEmergencyContact.value, auth0UserId.value);                    

                    var hasExistingMailing = false;
                    var deletedMailing = false;
                    if (personAddresses.value) {
                        personAddresses.value.forEach((singleAddress) => {
                            if (singleAddress.addressTypeId == 2) {
                                //if (showMailing && mailingAddressLine1.value != undefined && mailingAddressLine1.value != "") {
                                //console.log('Step through addresses for update, showMailing: ' + showMailing.value);
                                //console.log('Step through 2 - mailing Line 1 check: ' + (mailingAddressLine1.value != undefined && mailingAddressLine1.value != ""));
                                if (showMailing.value && (mailingAddressLine1.value != undefined && mailingAddressLine1.value != "")) {
                                    console.log('Updating existing Mailing');
                                    singleAddress.addressLine1 = mailingAddressLine1.value;
                                    singleAddress.addressLine2 = mailingAddressLine2.value;
                                    singleAddress.city = mailingCity.value;
                                    singleAddress.stateId = mailingStateId.value;
                                    singleAddress.zipCode = mailingZipCode.value;
                                    PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                                    hasExistingMailing = true;
                                } else {
                                    //console.log('Deleting existing Mailing: ' + singleAddress.personAddressId);
                                    PersonAddressService.deletePersonAddress(singleAddress.personAddressId, auth0UserId.value);
                                    deletedMailing = true;
                                }
                                
                            } else {
                                //saving 
                                console.log('Updating existing physical');
                                singleAddress.addressLine1 = addressLine1.value;
                                singleAddress.addressLine2 = addressLine2.value;
                                singleAddress.city = city.value;
                                singleAddress.stateId = stateId.value;
                                singleAddress.zipCode = zipCode.value;
                                PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                            }
                        });
                    }

                    if (showMailing.value && !hasExistingMailing && mailingAddressLine1.value != undefined && mailingAddressLine1.value != "") {
                        console.log("Adding New Mailing to Existing App");
                        personAddress.value = createPersonAddress();
                        personAddress.value.personId = person.value.personId;
                        personAddress.value.addressTypeId = 2; //mailing
                        personAddress.value.addressLine1 = mailingAddressLine1.value;
                        personAddress.value.addressLine2 = mailingAddressLine2.value;
                        personAddress.value.city = mailingCity.value;
                        personAddress.value.stateId = mailingStateId.value;
                        personAddress.value.zipCode = mailingZipCode.value;
                        personAddress.value.modifiedBy = "Update";
                        personAddress.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');
                        PersonAddressService.savePersonAddress(personAddress.value, auth0UserId.value);

                        //because we just added a mailing address,we need to make sure the existing address is set to physical and not physical/mailing
                        if (personAddresses.value) {
                            personAddresses.value.forEach((singleAddress) => {
                                if (singleAddress.addressTypeId == 3) {
                                    console.log("Updating existing physical/mailing to physical");
                                    //save the physical address as physical if physical/mailing
                                    singleAddress.addressTypeId = 1;
                                    singleAddress.addressLine1 = addressLine1.value;
                                    singleAddress.addressLine2 = addressLine2.value;
                                    singleAddress.city = city.value;
                                    singleAddress.stateId = stateId.value;
                                    singleAddress.zipCode = zipCode.value;
                                    PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                                }
                            });
                        }
                    }

                    if (deletedMailing) {
                        if (personAddresses.value) {
                            personAddresses.value.forEach((singleAddress) => {
                                if (singleAddress.addressTypeId == 1) {
                                    console.log("Updating existing physical to physical/mailing");
                                    singleAddress.addressTypeId = 3;
                                    singleAddress.addressLine1 = addressLine1.value;
                                    singleAddress.addressLine2 = addressLine2.value;
                                    singleAddress.city = city.value;
                                    singleAddress.stateId = stateId.value;
                                    singleAddress.zipCode = zipCode.value;
                                    PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                                }
                            });
                        }
                    }

                    //TODO: turn this back on to reset the app for review
                    existingApp.value.applicationResultId = 0;
                    ParticipantApplicationService.updateApplication(existingApp.value);

                    isSubmitted.value = true

                    // redirect to submitted page
                    router.push('submitted');

                } else {
                    isSubmitted.value = false
                }

                console.log("IsSubmitted: " + isSubmitted.value);

            } catch (e: unknown) {
                if (isAxiosError(e)) {
                    console.error(e.response?.data);
                } else {
                    console.error(e); // Log the entire error object if it doesn't have the expected structure
                }
            }

        //}
    }

    const handleCmAgencyFileUpload = (event) => {
        const file = event?.target?.files?.[0]; // Extract the first file from the event
        if (!file) {
            console.error("No file selected or invalid event structure:", event);
            return;
        }

        console.log('Valid file selected:', file);

        const reader = new FileReader();

        // Read the file as a Base64 string
        reader.onload = (readerEvent) => {
            const base64Content = readerEvent.target.result.split(",")[1]; // Extract Base64 part
            if (cmAgencyDocument.value) {
                cmAgencyDocument.value = {
                    filename: file.name,
                    contentBase64: base64Content,
                    modifiedBy: "Update",
                    modifiedDate: DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'),
                };
                console.log('update existing doc');
            } else {
                console.log('create doc');
                cmAgencyDocument.value = createDocument();
                cmAgencyDocument.value.filename = file.name;
                cmAgencyDocument.value.documentTypeId = 1;
                cmAgencyDocument.value.contentBase64 = base64Content;
                cmAgencyDocument.value.modifiedBy = "Create";
                cmAgencyDocument.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');
                console.log('create doc complete');
                
            }

            console.log("File uploaded successfully:", cmAgencyDocument.value);
            // Call the API to upload the document
            uploadDocumentToApi(cmAgencyDocument.value);
        };

        reader.onerror = (error) => {
            console.error("Error reading file:", error);
        };

        reader.readAsDataURL(file); // Start reading the file
    };



    function downloadFile(content: string, filename: string, mimeType: string = 'application/octet-stream') {
        const blob = DocumentService.base64ToBlob(content, mimeType);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    }

    async function uploadDocumentToApi (doc: IDocument) {
        console.log("Uploading to API:", doc);
        
        const documentId = await DocumentService.saveDocument(doc, auth0UserId.value);
        //console.log('documentId: ' + documentId);
        if (documentId > 0 && existingApp.value != null && existingApp.value.participantApplicationId != null && existingApp.value.participantApplicationId > 0) {
            console.log("Saved doc, saving to participant app");
            cmAgencyDocument.value.documentId = documentId;
            //ParticipantApplicationService.updateApplication(existingApp.value);
            if (participantApplicationCmAgencyDocument.value && participantApplicationCmAgencyDocument.value.participantApplicationDocumentId > 0) {
                participantApplicationCmAgencyDocument.value.documentId = documentId;
            } else {
                participantApplicationCmAgencyDocument.value = createParticipantApplicationDocument();
                participantApplicationCmAgencyDocument.value.documentId = documentId;
                participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
                participantApplicationCmAgencyDocument.value.modifiedBy = 'Create';
            }
            participantApplicationCmAgencyDocument.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');
            
            console.log('participant app id: ' + existingApp.value.participantApplicationId);
            //console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
            participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
            ParticipantApplicationDocumentService.saveParticipantApplicationDocument(participantApplicationCmAgencyDocument.value, auth0UserId.value);
            const cmAgencyDocResult = ParticipantApplicationDocumentService.getByParticipantApplicationId(existingApp.value.participantApplicationId, auth0UserId.value);
            participantApplicationCmAgencyDocument.value = cmAgencyDocResult;
        } else {
            console.log("Doc not saved to application yet.");

            cmAgencyDocument.value.documentId = documentId;
            console.log('new document id: ' + cmAgencyDocument.value.documentId);
            console.log('new doc filename: ' + cmAgencyDocument.value.filename);
        }
    }

    function validateForm() {
        let isValid = true;
        validationErrors.value = []
        console.log("Errors: " + validationErrors.value)
       // validationErrors.value = '';
        if (divisionId.value == "" || divisionId.value == null) {
            validationErrors.value.push({ text: 'Waiver Program is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (divisionId.value != "" && divisionId.value != null && divisionId.value > 0 && dateOfBirth.value != "" && dateOfBirth.value != null) {
            if (divisionId.value == 2) {
                console.log
                const age = DateHelper.getAge(new Date(dateOfBirth.value));
                if (age < 18) {
                    validationErrors.value.push({ text: 'You must be 18 or older in order to apply for the Community Choices Waiver.' });
                    isValid = false;
                    hasErrors.value = true;
                }
            }
        }
        if (firstName.value == "") { 
            validationErrors.value.push({ text: 'First Name is Required.'});
            isValid = false;
            hasErrors.value = true;
        }
        if (lastName.value == "") {
            validationErrors.value.push({text: 'Last Name is Required.'});
            isValid = false;
            hasErrors.value = true;
        }
        if (dateOfBirth.value == "") {
            validationErrors.value.push({ text: 'Date of Birth is Required.' });
            isValid = false;
            hasErrors.value = true;
        } else {
            if (new Date(dateOfBirth.value) >= new Date()) {
                validationErrors.value.push({ text: 'Date of Birth cannot be a future date.' });
                isValid = false;
                hasErrors.value = true;
            }
        }
        if (ssn.value == "") {
            validationErrors.value.push({ text: 'SSN is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (genderId.value == "" || genderId.value == null) {
            validationErrors.value.push({ text: 'Gender is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (ethnicityId.value == "" || ethnicityId.value == null) {
            validationErrors.value.push({ text: 'Ethnicity is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (countyId.value == "" || countyId.value == null) {
            validationErrors.value.push({ text: 'County is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (phoneTypeId.value == "" || phoneTypeId.value == null) {
            validationErrors.value.push({ text: 'Phone Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (phoneNumber.value == "" || phoneNumber.value == null) {
            validationErrors.value.push({ text: 'Phone Number is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emailTypeId.value == "" || emailTypeId.value == null) {
            validationErrors.value.push({ text: 'Email Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emailAddress.value == "" || emailAddress.value == null) {
            validationErrors.value.push({ text: 'Email is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        
        //if (addressTypeId.value == "" || addressTypeId.value == null) {
        //    validationErrors.value.push({ text: 'Address Type is Required.' });
        //    isValid = false;
        //    hasErrors.value = true;
        //}
        if (addressLine1.value == "" || addressLine1.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address Line 1 is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (city.value == "" || city.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address City is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (stateId.value == "" || stateId.value == null || stateId.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address State is Required.' });
            isValid = false;
            hasErrors.value = true;
        } else {
            console.log('validating state is Wyoming');
            if (stateId.value != StateEnum.Wyoming) {
                console.log('validating state is Wyoming - fail');
                validationErrors.value.push({ text: 'Physical address must be in Wyoming in order to apply for the waiver.' });
                isValid = false;
                hasErrors.value = true;
            }
        }
        if (zipCode.value == "" || zipCode.value == null || zipCode.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address Zip Code is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        if (showMailing.value) {
            if (mailingAddressLine1.value == "" || mailingAddressLine1.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address Line 1 is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
            if (mailingCity.value == "" || mailingCity.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address City is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
            if (mailingStateId.value == "" || mailingStateId.value == null || mailingStateId.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address State is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
            if (mailingZipCode.value == "" || mailingZipCode.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address Zip Code is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
        }

        if (emergencyContactName.value == "" || emergencyContactName.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Name is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactContactTypeId.value == "" || emergencyContactContactTypeId.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactPhoneTypeId.value == "" || emergencyContactPhoneTypeId.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Phone Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactPhoneNumber.value == "" || emergencyContactPhoneNumber.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Phone Number is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactAddressLine1.value == "" || emergencyContactAddressLine1.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address Line 1 is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactCity.value == "" || emergencyContactCity.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address City is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactStateId.value == "" || emergencyContactStateId.value == null || emergencyContactStateId.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address State is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactZipCode.value == "" || emergencyContactZipCode.value == null || emergencyContactZipCode.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address Zip Code is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        if (preferredMethodOfContactId.value == "" || preferredMethodOfContactId.value == null) {
            validationErrors.value.push({ text: 'Preferred Method of Contact is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        if (cmAgencyWyNumber.value == "" || cmAgencyWyNumber.value == null) {
            validationErrors.value.push({ text: 'Case Management Agency is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        return isValid;
    }

    function onDivisionTypeChange() {
        //console.log("Selected WaiverType: " + divisionId.value);
        if (divisionId.value == "1") {
            ccwFields.value = false;
            ddFields.value = true;
            certificationTypeId.value = 8; //support
            LookupService.getCmAgencies(certificationTypeId.value, 1).then(result => cmAgencies.value = result).then(() => isLoading.value = false);
        } else if (divisionId.value == "2") {
            ccwFields.value = true;
            ddFields.value = false;
            certificationTypeId.value = 10; //ccw
            LookupService.getCmAgencies(certificationTypeId.value, 3).then(result => cmAgencies.value = result).then(() => isLoading.value = false);
        } else {
            ccwFields.value = false;
            ddFields.value = false;
            unknownWaiver.value = true;
        }
    }

    
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_form, {
      modelValue: _unref(valid),
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event)),
      ref: "form"
    }, {
      default: _withCtx(() => [
        (_unref(unregistered))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createTextVNode(" You are currently not registered, or not logged in. You will be unable to track any application submitted through this site unless you are "),
                _createVNode(_component_router_link, { to: { name: 'register' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("registered")
                  ]),
                  _: 1
                }),
                _createTextVNode(" and "),
                _createVNode(_component_router_link, { to: { name: 'login' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("logged in")
                  ]),
                  _: 1
                }),
                _createTextVNode(". ")
              ])
            ]))
          : (_unref(registered))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                (!_unref(hasNoApplication))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, [
                        _createTextVNode("and your application has been successfully submitted. You can track any application submitted through this site by going to the "),
                        _createVNode(_component_router_link, { to: { name: 'application-status' } }, {
                          default: _withCtx(() => [
                            _createTextVNode("Application Status")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" page."),
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _createElementVNode("h3", null, [
                        _createTextVNode(" Application Status: "),
                        (_unref(statusPending))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "PENDING"))
                          : _createCommentVNode("", true),
                        (_unref(statusMoreInfo))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "MORE INFORMATION REQUIRED"))
                          : _createCommentVNode("", true),
                        (_unref(statusDeclined))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "DECLINED"))
                          : _createCommentVNode("", true),
                        (_unref(statusAccepted))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "ACCEPTED"))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(statusMoreInfo))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Your application requires additional information in order to be processed. Please see notes below, make the necessary updates, and click 'Submit Updates' at the bottom of the page."))
                        : _createCommentVNode("", true),
                      _hoisted_15,
                      _createElementVNode("span", {
                        innerHTML: !_unref(existingApp).applicationResultNote || _unref(existingApp).applicationResultNote.trim() === '' ? '' : '<b>Notes:</b> ' + _unref(existingApp).applicationResultNote + '<br /><br />'
                      }, null, 8, _hoisted_16),
                      _createTextVNode(" Please review submitted information below: ")
                    ]))
                  : _createCommentVNode("", true),
                (_unref(hasNoApplication))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createTextVNode("but your application has not yet been submitted."),
                      _hoisted_18,
                      _hoisted_19
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        (loadingData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Loading..."))
          : (_openBlock(), _createBlock(_component_v_container, {
              key: 3,
              density: "compact",
              style: {"text-align":"left"}
            }, {
              default: _withCtx(() => [
                (!_unref(registered))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "8"
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_unref(hasNoApplication))
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_22,
                            _createTextVNode(" " + _toDisplayString(new Date((_unref(existingApp)).applicationDate).toLocaleDateString('en-US')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(_unref(existingApp).waiverProgramName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(registered))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "4",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Which waiver program are you applying for? "),
                              _createVNode(_component_v_select, {
                                modelValue: _unref(divisionId),
                                "onUpdate:modelValue": [
                                  _cache[0] || (_cache[0] = ($event: any) => (_isRef(divisionId) ? (divisionId).value = $event : divisionId = $event)),
                                  onDivisionTypeChange
                                ],
                                items: divisions.value,
                                "item-value": "divisionId",
                                "item-title": "description",
                                label: "Waiver Program"
                              }, {
                                counter: _withCtx(() => []),
                                _: 1
                              }, 8, ["modelValue", "items"]),
                              _createTextVNode(),
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_unref(ccwFields))
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            style: {"text-align":"left","margin-top":"-40px"},
                            dense: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "40",
                                md: "12",
                                style: {"text-align":"left","margin-bottom":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_26,
                                  _createTextVNode(" For more information about CCW Participant Services and Eligibility, please visit: "),
                                  _hoisted_27,
                                  _hoisted_28
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(ddFields))
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 1,
                            style: {"text-align":"left","margin-top":"-40px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "40",
                                md: "12",
                                style: {"text-align":"left","margin-bottom":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_29,
                                  _createTextVNode(" For more information about DD Participant Services and Eligibility, please visit: "),
                                  _hoisted_30,
                                  _hoisted_31
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(unknownWaiver))
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 2,
                            style: {"text-align":"left","margin-top":"-40px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "40",
                                md: "12",
                                style: {"text-align":"left","margin-bottom":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_32,
                                  _createTextVNode(" For more information about DD Participant Services and Eligibility, please visit: "),
                                  _hoisted_33,
                                  _hoisted_34,
                                  _hoisted_35,
                                  _hoisted_36,
                                  _hoisted_37,
                                  _createTextVNode(" For more information about CCW Participant Services and Eligibility, please visit: "),
                                  _hoisted_38,
                                  _hoisted_39
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _unref(firstName),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : firstName = $event)),
                                label: "First Name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _unref(middleName),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(middleName) ? (middleName).value = $event : middleName = $event)),
                                label: "Middle Name",
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _unref(lastName),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : lastName = $event)),
                                label: "Last Name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _unref(preferredName),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(preferredName) ? (preferredName).value = $event : preferredName = $event)),
                                label: "Preferred Name",
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                items: suffixes.value,
                                modelValue: _unref(suffixId),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(suffixId) ? (suffixId).value = $event : suffixId = $event)),
                                "item-value": "suffixId",
                                "item-title": "description",
                                name: "suffix",
                                label: "Suffix",
                                clearable: ""
                              }, {
                                counter: _withCtx(() => []),
                                _: 1
                              }, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _unref(dateOfBirth),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(dateOfBirth) ? (dateOfBirth).value = $event : dateOfBirth = $event)),
                                label: "Birth Date",
                                type: "date"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_text_field, {
                                modelValue: _unref(ssn),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(ssn) ? (ssn).value = $event : ssn = $event)),
                                label: "SSN"
                              }, null, 8, ["modelValue"]), [
                                [_unref(vMaska), void 0, ssnMask]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                items: genderTypes.value,
                                modelValue: _unref(genderId),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(genderId) ? (genderId).value = $event : genderId = $event)),
                                "item-value": "genderId",
                                "item-title": "description",
                                label: "Gender"
                              }, {
                                counter: _withCtx(() => []),
                                _: 1
                              }, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                items: ethnicities.value,
                                modelValue: _unref(ethnicityId),
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(ethnicityId) ? (ethnicityId).value = $event : ethnicityId = $event)),
                                "item-value": "ethnicityId",
                                "item-title": "description",
                                name: "ethnicity",
                                label: "Ethnicity"
                              }, {
                                counter: _withCtx(() => []),
                                _: 1
                              }, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_text_field, {
                                modelValue: _unref(medicaidId),
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(medicaidId) ? (medicaidId).value = $event : medicaidId = $event)),
                                label: "Medicaid ID"
                              }, null, 8, ["modelValue"]), [
                                [_unref(vMaska), void 0, medicaidIdMask]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            "cols-": "12",
                            md: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _unref(isMilitary),
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(isMilitary) ? (isMilitary).value = $event : isMilitary = $event)),
                                label: "Are you, your spouse or parent a veteran or an active-duty member of the U.S. military?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                items: counties.value,
                                modelValue: _unref(countyId),
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(countyId) ? (countyId).value = $event : countyId = $event)),
                                "item-value": "countyId",
                                "item-title": "description",
                                name: "county",
                                label: "County"
                              }, {
                                counter: _withCtx(() => []),
                                _: 1
                              }, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        variant: "outlined",
                        title: "Contact Info",
                        class: "text-left",
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: phoneTypes.value,
                                      modelValue: _unref(phoneTypeId),
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(phoneTypeId) ? (phoneTypeId).value = $event : phoneTypeId = $event)),
                                      "item-value": "phoneTypeId",
                                      "item-title": "description",
                                      name: "phoneType",
                                      label: "Phone Type"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_text_field, {
                                      modelValue: _unref(phoneNumber),
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(phoneNumber) ? (phoneNumber).value = $event : phoneNumber = $event)),
                                      label: "Phone",
                                      placeholder: "(000) 000-0000"
                                    }, null, 8, ["modelValue"]), [
                                      [_unref(vMaska), void 0, phoneMask]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: emailTypes.value,
                                      modelValue: _unref(emailTypeId),
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(emailTypeId) ? (emailTypeId).value = $event : emailTypeId = $event)),
                                      "item-value": "emailTypeId",
                                      "item-title": "description",
                                      name: "emailType",
                                      label: "Email Type"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emailAddress),
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(emailAddress) ? (emailAddress).value = $event : emailAddress = $event)),
                                      label: "Email",
                                      placeholder: "johndoe@gmail.com",
                                      type: "email"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        variant: "outlined",
                        title: "Physical Address",
                        class: "text-left",
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(addressLine1),
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(addressLine1) ? (addressLine1).value = $event : addressLine1 = $event)),
                                      label: "Address Line 1"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(addressLine2),
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(addressLine2) ? (addressLine2).value = $event : addressLine2 = $event)),
                                      label: "Address Line 2"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(city),
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(city) ? (city).value = $event : city = $event)),
                                      label: "City"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: states.value,
                                      modelValue: _unref(stateId),
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(stateId) ? (stateId).value = $event : stateId = $event)),
                                      "item-value": "stateId",
                                      "item-title": "description",
                                      name: "state",
                                      label: "State"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(zipCode),
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(zipCode) ? (zipCode).value = $event : zipCode = $event)),
                                      label: "Zip"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        variant: "outlined",
                        title: "Mailing Address (if different from Physical Address)",
                        class: "text-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _unref(showMailing),
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(showMailing) ? (showMailing).value = $event : showMailing = $event)),
                              label: "Do you have a different mailing address than the address entered above?"
                            }, null, 8, ["modelValue"])
                          ]),
                          (_unref(showMailing))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createVNode(_component_v_row, { dense: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "11",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _unref(mailingAddressLine1),
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(mailingAddressLine1) ? (mailingAddressLine1).value = $event : mailingAddressLine1 = $event)),
                                          label: "Address Line 1"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { dense: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "11",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _unref(mailingAddressLine2),
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(mailingAddressLine2) ? (mailingAddressLine2).value = $event : mailingAddressLine2 = $event)),
                                          label: "Address Line 2"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { dense: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "8",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _unref(mailingCity),
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_isRef(mailingCity) ? (mailingCity).value = $event : mailingCity = $event)),
                                          label: "City"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "8",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          items: states.value,
                                          modelValue: _unref(mailingStateId),
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(mailingStateId) ? (mailingStateId).value = $event : mailingStateId = $event)),
                                          "item-value": "stateId",
                                          "item-title": "description",
                                          name: "mailingState",
                                          label: "State"
                                        }, {
                                          counter: _withCtx(() => []),
                                          _: 1
                                        }, 8, ["items", "modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "8",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _unref(mailingZipCode),
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_isRef(mailingZipCode) ? (mailingZipCode).value = $event : mailingZipCode = $event)),
                                          label: "Zip"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { style: {"margin-top":"10px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                items: preferredMethodsOfContact.value,
                                modelValue: _unref(preferredMethodOfContactId),
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_isRef(preferredMethodOfContactId) ? (preferredMethodOfContactId).value = $event : preferredMethodOfContactId = $event)),
                                "item-value": "preferredMethodOfContactId",
                                "item-title": "description",
                                name: "preferredMethodOfContact",
                                label: "Preferred Method Of Contact"
                              }, {
                                counter: _withCtx(() => []),
                                _: 1
                              }, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            "cols-": "12",
                            md: "8"
                          }, {
                            default: _withCtx(() => [
                              (_unref(isOver21))
                                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                    key: 0,
                                    modelValue: _unref(isApplyingForAbi),
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_isRef(isApplyingForAbi) ? (isApplyingForAbi).value = $event : isApplyingForAbi = $event)),
                                    label: "Are you applying for the Acquired Brain Injury Waiver?"
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        variant: "outlined",
                        title: "Emergency Contact Info",
                        class: "text-left",
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactName),
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_isRef(emergencyContactName) ? (emergencyContactName).value = $event : emergencyContactName = $event)),
                                      label: "Name"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: contactTypes.value,
                                      modelValue: _unref(emergencyContactContactTypeId),
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_isRef(emergencyContactContactTypeId) ? (emergencyContactContactTypeId).value = $event : emergencyContactContactTypeId = $event)),
                                      "item-value": "contactTypeId",
                                      "item-title": "description",
                                      name: "emergencyContactType",
                                      label: "Contact Type"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: phoneTypes.value,
                                      modelValue: _unref(emergencyContactPhoneTypeId),
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_isRef(emergencyContactPhoneTypeId) ? (emergencyContactPhoneTypeId).value = $event : emergencyContactPhoneTypeId = $event)),
                                      "item-value": "phoneTypeId",
                                      "item-title": "description",
                                      name: "emergencyContactPhoneType",
                                      label: "Phone Type"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactPhoneNumber),
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_isRef(emergencyContactPhoneNumber) ? (emergencyContactPhoneNumber).value = $event : emergencyContactPhoneNumber = $event)),
                                      label: "Phone",
                                      placeholder: "(000) 000-0000"
                                    }, null, 8, ["modelValue"]), [
                                      [_unref(vMaska), void 0, phoneMask]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: emailTypes.value,
                                      modelValue: _unref(emergencyContactEmailTypeId),
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_isRef(emergencyContactEmailTypeId) ? (emergencyContactEmailTypeId).value = $event : emergencyContactEmailTypeId = $event)),
                                      "item-value": "emailTypeId",
                                      "item-title": "description",
                                      name: "emergencyContactEmailType",
                                      label: "Email Type"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactEmailAddress),
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_isRef(emergencyContactEmailAddress) ? (emergencyContactEmailAddress).value = $event : emergencyContactEmailAddress = $event)),
                                      label: "Email",
                                      placeholder: "johndoe@gmail.com",
                                      type: "email"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: addressTypes.value,
                                      modelValue: _unref(emergencyContactAddressTypeId),
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_isRef(emergencyContactAddressTypeId) ? (emergencyContactAddressTypeId).value = $event : emergencyContactAddressTypeId = $event)),
                                      "item-value": "addressTypeId",
                                      "item-title": "description",
                                      name: "emergencyContactAddressType",
                                      label: "Address Type"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactAddressLine1),
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_isRef(emergencyContactAddressLine1) ? (emergencyContactAddressLine1).value = $event : emergencyContactAddressLine1 = $event)),
                                      label: "Address Line 1"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactAddressLine2),
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_isRef(emergencyContactAddressLine2) ? (emergencyContactAddressLine2).value = $event : emergencyContactAddressLine2 = $event)),
                                      label: "Address Line 2"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactCity),
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_isRef(emergencyContactCity) ? (emergencyContactCity).value = $event : emergencyContactCity = $event)),
                                      label: "City"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: states.value,
                                      modelValue: _unref(emergencyContactStateId),
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_isRef(emergencyContactStateId) ? (emergencyContactStateId).value = $event : emergencyContactStateId = $event)),
                                      "item-value": "stateId",
                                      "item-title": "description",
                                      name: "emergencyContactState",
                                      label: "State"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _unref(emergencyContactZipCode),
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_isRef(emergencyContactZipCode) ? (emergencyContactZipCode).value = $event : emergencyContactZipCode = $event)),
                                      label: "Zip"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: preferredMethodsOfContact.value,
                                      modelValue: _unref(emergencyContactPreferredMethodOfContactId),
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_isRef(emergencyContactPreferredMethodOfContactId) ? (emergencyContactPreferredMethodOfContactId).value = $event : emergencyContactPreferredMethodOfContactId = $event)),
                                      "item-value": "preferredMethodOfContactId",
                                      "item-title": "description",
                                      name: "emergencyContactPreferredMethodOfContact",
                                      label: "Preferred Method Of Contact"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        variant: "outlined",
                        title: "Case Management Agency Selection",
                        class: "text-left",
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_v_row, {
                              dense: "",
                              cols: "12",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: cmAgencies.value,
                                      modelValue: _unref(cmAgencyWyNumber),
                                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_isRef(cmAgencyWyNumber) ? (cmAgencyWyNumber).value = $event : cmAgencyWyNumber = $event)),
                                      "item-value": "wyNumber",
                                      "item-title": "providerName",
                                      name: "cmAgencyWyNumberName",
                                      label: "Case Management Agency"
                                    }, {
                                      counter: _withCtx(() => []),
                                      _: 1
                                    }, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(allowUpload))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "If you have a completed Case Management Selection form, please upload it here:"))
                                      : _createCommentVNode("", true),
                                    (!_unref(allowUpload) && _unref(cmAgencyDocument) && _unref(cmAgencyDocument).documentId && _unref(cmAgencyDocument).documentId > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, "View your uploaded CM Selection Form:"))
                                      : _createCommentVNode("", true),
                                    (_unref(allowUpload))
                                      ? (_openBlock(), _createBlock(_component_v_file_input, {
                                          key: 2,
                                          label: "Upload Document",
                                          accept: ".pdf,.doc,.docx",
                                          onChange: handleCmAgencyFileUpload,
                                          outlined: "",
                                          dense: ""
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                (_unref(ddFields))
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_51
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_unref(ccwFields))
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_52
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(cmAgencyDocument) && _unref(cmAgencyDocument).documentId && _unref(cmAgencyDocument).documentId > 0)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 0,
                                          color: "primary",
                                          text: "",
                                          onClick: _cache[44] || (_cache[44] = ($event: any) => (downloadFile(_unref(cmAgencyDocument).contentBase64, _unref(cmAgencyDocument).filename, 'application/pdf')))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { left: "" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-download")
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" " + _toDisplayString(_unref(cmAgencyDocument).filename), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      (_unref(hasErrors))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validationErrors), (err) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: err.text
                                }, _toDisplayString(err.text), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "4"
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                (_unref(hasNoApplication))
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      onClick: saveNewApplication,
                                      block: "",
                                      color: "indigo-darken-3",
                                      size: "medium",
                                      variant: "flat"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Submit")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_unref(requiresEdit))
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      onClick: updateApplication,
                                      block: "",
                                      color: "indigo-darken-3",
                                      size: "medium",
                                      variant: "flat"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Submit Updates")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})